(() => {
  const productIds = new Set(['8472281415780', '8460548538468', '8662433071204']);
  const reveal = root => requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('rf-pull-load-ready')));
  function addBenefits(root,info) {
    if (!info) return;
    if(info.querySelector('.rf-pull-overview'))return info.querySelector('.rf-pull-overview');
    const seconds=root.dataset.productId==='8460548538468';
    const items=seconds ? [
      ['tag','Discounted seconds','Typically 40% off'],
      ['layers','Multiple options','Standard & detectable'],
      ['ruler','Possible splices','Footage & markings vary'],
      ['info','Sold as-is','No returns · Limited stock']
    ] : [
      ['drop','Pre-lubricated','Helps reduce friction'],
      ['shield','Durable polyester','Abrasion-resistant yarns'],
      ['ruler','Footage markings','Track pulling progress'],
      ['mill','Made in the USA','Woven in Titusville, PA']
    ];
    const shapes={drop:'<path d="M12 3s-6 7-6 11a6 6 0 0 0 12 0c0-4-6-11-6-11Z"/><path d="M9 14a3 3 0 0 0 3 3"/>',shield:'<path d="m12 3 8 3v6c0 5-8 9-8 9s-8-4-8-9V6Z"/><path d="m8 12 3 3 5-6"/>',ruler:'<rect x="3" y="6" width="18" height="12" rx="2"/><path d="M7 6v5m5-5v3m5-3v5"/>',mill:'<path d="M3 21V9l6 4V9l6 4V4h5v17Z"/><path d="M7 17h1m4 0h1m4 0h1"/>',tag:'<path d="M3 3h8l10 10-8 8L3 11Z"/><circle cx="7" cy="7" r="1"/>',layers:'<path d="m12 3 10 6-10 6L2 9Zm-9 11 9 6 9-6"/>',info:'<circle cx="12" cy="12" r="9"/><path d="M12 11v6m0-10v1"/>'};
    const panel=document.createElement('ul');panel.className='rf-pull-benefits';panel.setAttribute('aria-label',seconds?'About seconds-quality pull tape':'Pull tape features');
    items.forEach(([icon,label,detail])=>{
      const li=document.createElement('li');
      const graphic=document.createElementNS('http://www.w3.org/2000/svg','svg');graphic.setAttribute('viewBox','0 0 24 24');graphic.setAttribute('fill','none');graphic.setAttribute('stroke','currentColor');graphic.setAttribute('stroke-width','1.6');graphic.setAttribute('stroke-linecap','round');graphic.setAttribute('stroke-linejoin','round');graphic.setAttribute('aria-hidden','true');graphic.innerHTML=shapes[icon];
      const copy=document.createElement('div'),title=document.createElement('strong'),text=document.createElement('span');title.textContent=label;text.textContent=detail;copy.append(title,text);li.append(graphic,copy);panel.append(li);
    });
    const overview=document.createElement('div');overview.className='rf-pull-overview';overview.append(panel);
    info.querySelector('.product__title')?.after(overview);
    return overview;
  }
  function initialize() {
    document.querySelectorAll('product-info').forEach(root => {
      if (!productIds.has(root.dataset.productId) || root.dataset.rfDesktopDetailsReady) return;
      const info = root.querySelector('[id^="ProductInfo-"]');
      const overview=addBenefits(root,info);
      if (root.dataset.productId === '8662433071204') {
        const details=info.querySelector('.rf-wp-details');
        if(details&&overview&&!overview.querySelector('nav')){if(!details.id)details.id='rf-wholesale-product-details';const nav=document.createElement('nav');nav.className='rf-pull-desktop-details__nav';nav.setAttribute('aria-label','Product information below');const link=document.createElement('a');link.className='rf-pull-overview__link';link.href='#'+details.id;link.textContent='Details & specs ↓';nav.append(link);overview.append(nav);}
        if(details&&!details.querySelector('.rf-pull-back-to-options')){const back=document.createElement('a');back.className='rf-pull-back-to-options';back.href='#'+(info.querySelector('.rf-wp-start')?.id||info.querySelector('.rf-wp')?.id);back.textContent='Back to product options ↑';details.append(back);}
        reveal(root); return;
      }
      const description = info?.querySelector('.product__description');
      const productGrid = info?.closest('.product');
      const picker = info?.querySelector('variant-selects');
      if (!description || !productGrid || !picker) return;
      const seconds = root.dataset.productId === '8460548538468';
      const section = document.createElement('section');
      section.id = 'rf-pull-details-desktop-' + root.dataset.productId;
      section.className = 'rf-pull-desktop-details' + (seconds ? ' rf-pull-details--seconds' : '');
      section.setAttribute('aria-labelledby', section.id + '-title');
      const header = document.createElement('div');
      header.className = 'rf-pull-desktop-details__header';
      const heading = document.createElement('h2');
      heading.id = section.id + '-title';
      heading.textContent = seconds ? 'About seconds-quality pull tape' : 'Pull tape details & specifications';
      const back = document.createElement('a');
      back.href = '#' + picker.id;
      back.textContent = 'Back to product options ↑';
      back.addEventListener('click', event => {
        event.preventDefault();
        const target = picker.querySelector('.rf-order-prompt:not([hidden])') || picker;
        const header = document.querySelector('sticky-header');
        const offset = header ? header.getBoundingClientRect().height : 0;
        window.scrollTo({top:Math.max(0,scrollY + target.getBoundingClientRect().top - offset - 16),behavior:'instant'});
      });
      header.append(heading, back);
      const copy = description.cloneNode(true);
      // Keep the original mobile content and its handlers in their existing location.
      copy.querySelector('#rf-pull-tape-detail-assurance')?.remove();
      const idMap = new Map();
      [copy, ...copy.querySelectorAll('[id]')].forEach(node => {
        if (!node.id) return;
        const old = node.id;
        node.id = section.id + '-' + old;
        idMap.set(old, node.id);
      });
      copy.querySelectorAll('a[href^="#"]').forEach(link => {
        const target = idMap.get(link.getAttribute('href').slice(1));
        if (target) link.setAttribute('href', '#' + target);
      });
      section.append(header, copy);
      productGrid.after(section);
      const mobileBack = document.createElement('a');
      mobileBack.href = '#' + picker.id;
      mobileBack.className = 'rf-pull-back-to-options';
      mobileBack.textContent = 'Take me back ↑';
      description.append(mobileBack);
      const originalTrigger = info.querySelector('.rf-pt-actions a[href^="#"]') ||
        [...info.querySelectorAll('a')].find(a => a.getAttribute('href') === '#' + description.id);
      originalTrigger?.classList.add('rf-pull-desktop-details__original-trigger');
      const nav = document.createElement('nav');
      nav.className = 'rf-pull-desktop-details__nav';
      nav.setAttribute('aria-label', 'Product information below');
      const trigger = document.createElement('a');
      trigger.className = 'rf-pull-desktop-details__trigger';
      trigger.href = '#' + section.id;
      trigger.textContent = seconds ? 'What are seconds? ↓' : 'Details & specs ↓';
      nav.append(trigger);
      if (seconds) {
        nav.classList.add('rf-pull-seconds-shortcuts');
        const shop = document.createElement('a');
        shop.href = '/products/polyester-pull-tape';
        shop.textContent = 'Shop First-Quality Pull Tape →';
        shop.className = 'rf-pull-first-quality-shortcut';
        nav.append(shop);
        overview.append(nav);
        trigger.addEventListener('click', () => {
          trigger.href = '#' + (matchMedia('(min-width:990px)').matches ? section.id : description.id);
        });
      } else {
        const wholesale=info.querySelector('.rf-pt-actions a[href*="/products/wholesale-polyester-pull-tape"]')||document.createElement('a');
        wholesale.href='/products/wholesale-polyester-pull-tape';wholesale.className='rf-pull-overview__link';wholesale.textContent='Shop Wholesale Pull Tape →';
        nav.append(wholesale);overview.append(nav);
        const oldActions=info.querySelector('.rf-pt-actions');if(oldActions&&Array.from(oldActions.querySelectorAll('a')).every(a=>a.classList.contains('rf-pull-desktop-details__original-trigger')))oldActions.remove();
      }
      root.dataset.rfDesktopDetailsReady = 'true';
      root.classList.add('rf-pull-desktop-details-ready');
      reveal(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
